import React from 'react'
import USD from "../../../components/usd"

export default function FieldReservation (props) {
  if (!props.cart.reservationId) return null

  const showMinus = !!props.onClickMinus
  
  return (
    <tr className='shop-cart-row'>
      <td className='shop-cart-row__name'>
        {showMinus &&
          <span>
            <a className='shop-cart-row__controll' onClick={props.onClickMinus}>&ndash;</a>
            &nbsp;
          </span>
        }
        <span onClick={!showMinus ? props.onClick : undefined}>Field Reservation</span>
      </td>
      <td className='shop-cart-row__cost'>
        <span onClick={!showMinus ? props.onClick : undefined}>
          <USD val={props.cart.reservationPrice}/>
        </span>
      </td>
    </tr>
  )
}
